<div class="row">
  <div class="whitelist col-md-6">
    <h2>
      <i class="fa fa-table"></i>&nbsp;Kalkulationstabellen
      <button type="button"
              class="btn btn-default btn-sm btn-link"
              [title]="`Ausgeblendete ${(showHidden ? 'verbergen' : 'anzeigen')}`"
              (click)="toggleShowHidden()">
        <i class="fa" [ngClass]="{'fa-eye-slash' : !showHidden, 'fa-eye': showHidden}"></i>
      </button>
    </h2>

    @for (process of displayedProcesses; track process.id) {
      <a uiSref="a.calculation.list"
        [uiParams]="{id: process.id}"
        [uiOptions]="{reload: false}"
        (click)="setCurrentElement(process.id)"
        >
        <div class="whitelist-item" [ngClass]="{'selected': process.id === current?.id}">
          <div class="whitelist-item-detail">
            @if (process.hidden) {
              <span class="label label-danger">ausgeblendet</span>
              } {{ process.name }}
            </div>
          </div>
        </a>
      }
    </div>

    @if (current) {
      <div class="col-md-3">
        <h2>
          @if (current.hidden) {
            <span class="label label-danger">ausgeblendet</span>
          }
          {{ current.name }}
        </h2>
        <div class="whitelist calculationlist">
          @for (layout of current.layouts; track layout) {
            <a uiSref="a.calculation.table.view" [uiParams]="{id: current.id, table: layout.id}">
              <div class="whitelist-item">
                <div class="whitelist-item-detail">
                  {{ layout.name }}
                </div>
              </div>
            </a>
          }
        </div>
      </div>
    }

    @if (!!current) {
      <div class="col-md-3">
        <div class="row">
          <div class="col-md-12">
            <button type="button" class="btn btn-danger btn-md pull-left" (click)="openModal()">
              Kalkulation kopieren
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12"></div>
          <div class="col-md-12">
            <button type="button" class="btn btn-warning btn-md pull-left" (click)="toggleHide()">
              Kalkulation
              @if (!current.hidden) {
                <span>ausblenden</span>
              }
              @if (current.hidden) {
                <span>anzeigen</span>
              }
            </button>
          </div>
        </div>
        @if (current.typ === 'Deutschland') {
          <calculation-list-form [current]="current" (reload)="reload()">
          </calculation-list-form>
        }
      </div>
    }

  </div>
